import 'slick-carousel'

const $win = $(window)

export const sliderResize = ($slider, desktopFirst, options, resolutionMobile, destroyMobile) => {
  let checkScreenFirst = $win.width() > 1023
  let checkScreenSecond = $win.width() < 1024

  if (resolutionMobile) {
    checkScreenFirst = $win.width() > 767
    checkScreenSecond = $win.width() < 768
  }

  if (desktopFirst) {
    if (resolutionMobile) {
      checkScreenFirst = $win.width() < 768
      checkScreenSecond = $win.width() > 767
    } else {
      checkScreenFirst = $win.width() < 1024
      checkScreenSecond = $win.width() > 1023
    }
  }

  if (destroyMobile && !resolutionMobile) {
    if (($slider.hasClass('slick-slider') && $win.width() < 768) || (checkScreenSecond && $slider.hasClass('slick-slider'))) {
      $slider.slick('slickUnfilter').slick('unslick')
    } else if (checkScreenFirst && !$slider.hasClass('slick-slider') && $win.width() > 767) {
      $slider.slick(options)
    }
  } else {
    if (checkScreenFirst && !$slider.hasClass('slick-slider')) {
      $slider.slick(options)
    } else if (checkScreenSecond && $slider.hasClass('slick-slider')) {
      $slider.slick('slickUnfilter').slick('unslick')
    }
  }
}
